module.exports = __webpack_public_path__ + "static/ride-spot-pin-744955502a89b56413ec0d25beef9330.png";